/**
 * Color design token reference: https://slate.faire.team/tokens/colors
 */
export enum ColorTokenKey {
  COLOR_TOKEN_KEY_UNKNOWN = 'COLOR_TOKEN_KEY_UNKNOWN',
  /**
   * @deprecated
   */
  ACTION_BORDER_DEFAULT = 'ACTION_BORDER_DEFAULT',
  /**
   * @deprecated
   */
  ACTION_BORDER_DISABLED = 'ACTION_BORDER_DISABLED',
  /**
   * @deprecated
   */
  ACTION_BORDER_ENABLED = 'ACTION_BORDER_ENABLED',
  /**
   * @deprecated
   */
  ACTION_BORDER_HOVER = 'ACTION_BORDER_HOVER',
  /**
   * @deprecated
   */
  ACTION_BORDER_MUTED = 'ACTION_BORDER_MUTED',
  /**
   * @deprecated
   */
  ACTION_BORDER_SUBDUED = 'ACTION_BORDER_SUBDUED',
  /**
   * @deprecated
   */
  ACTION_ICON_DEFAULT = 'ACTION_ICON_DEFAULT',
  /**
   * @deprecated
   */
  ACTION_ICON_DISABLED = 'ACTION_ICON_DISABLED',
  /**
   * @deprecated
   */
  ACTION_ICON_ENABLED = 'ACTION_ICON_ENABLED',
  /**
   * @deprecated
   */
  ACTION_ICON_HOVER = 'ACTION_ICON_HOVER',
  /**
   * @deprecated
   */
  ACTION_ICON_MUTED = 'ACTION_ICON_MUTED',
  /**
   * @deprecated
   */
  ACTION_ICON_SUBDUED = 'ACTION_ICON_SUBDUED',
  /**
   * @deprecated
   */
  ACTION_SURFACE_DEFAULT = 'ACTION_SURFACE_DEFAULT',
  /**
   * @deprecated
   */
  ACTION_SURFACE_DISABLED = 'ACTION_SURFACE_DISABLED',
  /**
   * @deprecated
   */
  ACTION_SURFACE_ENABLED = 'ACTION_SURFACE_ENABLED',
  /**
   * @deprecated
   */
  ACTION_SURFACE_HOVER = 'ACTION_SURFACE_HOVER',
  /**
   * @deprecated
   */
  ACTION_SURFACE_MUTED = 'ACTION_SURFACE_MUTED',
  /**
   * @deprecated
   */
  ACTION_SURFACE_SUBDUED = 'ACTION_SURFACE_SUBDUED',
  /**
   * @deprecated
   */
  ACTION_TEXT_DEFAULT = 'ACTION_TEXT_DEFAULT',
  /**
   * @deprecated
   */
  ACTION_TEXT_DISABLED = 'ACTION_TEXT_DISABLED',
  /**
   * @deprecated
   */
  ACTION_TEXT_ENABLED = 'ACTION_TEXT_ENABLED',
  /**
   * @deprecated
   */
  ACTION_TEXT_HOVER = 'ACTION_TEXT_HOVER',
  /**
   * @deprecated
   */
  ACTION_TEXT_MUTED = 'ACTION_TEXT_MUTED',
  /**
   * @deprecated
   */
  ACTION_TEXT_SUBDUED = 'ACTION_TEXT_SUBDUED',
  /**
   * @deprecated
   */
  CORE_BACKGROUND_PRIMARY = 'CORE_BACKGROUND_PRIMARY',
  /**
   * @deprecated
   */
  CORE_BACKGROUND_SECONDARY = 'CORE_BACKGROUND_SECONDARY',
  /**
   * @deprecated
   */
  CORE_BACKGROUND_TERTIARY = 'CORE_BACKGROUND_TERTIARY',
  CORE_BORDER_CRITICAL = 'CORE_BORDER_CRITICAL',
  CORE_BORDER_PRIMARY = 'CORE_BORDER_PRIMARY',
  CORE_BORDER_SUCCESS = 'CORE_BORDER_SUCCESS',
  CORE_BORDER_WARNING = 'CORE_BORDER_WARNING',
  CORE_ICON_CRITICAL = 'CORE_ICON_CRITICAL',
  CORE_ICON_PRIMARY = 'CORE_ICON_PRIMARY',
  CORE_ICON_SECONDARY = 'CORE_ICON_SECONDARY',
  CORE_ICON_SUCCESS = 'CORE_ICON_SUCCESS',
  CORE_ICON_WARNING = 'CORE_ICON_WARNING',
  CORE_SURFACE_CRITICAL = 'CORE_SURFACE_CRITICAL',
  CORE_SURFACE_SUCCESS = 'CORE_SURFACE_SUCCESS',
  CORE_SURFACE_WARNING = 'CORE_SURFACE_WARNING',
  CORE_TEXT_CRITICAL = 'CORE_TEXT_CRITICAL',
  CORE_TEXT_PRIMARY = 'CORE_TEXT_PRIMARY',
  CORE_TEXT_PRIMARY_INVERSE = 'CORE_TEXT_PRIMARY_INVERSE',
  CORE_TEXT_SECONDARY = 'CORE_TEXT_SECONDARY',
  DECORATIVE_ICON_10 = 'DECORATIVE_ICON_10',
  DECORATIVE_ICON_20 = 'DECORATIVE_ICON_20',
  DECORATIVE_ICON_30 = 'DECORATIVE_ICON_30',
  DECORATIVE_ICON_40 = 'DECORATIVE_ICON_40',
  DECORATIVE_ICON_50 = 'DECORATIVE_ICON_50',
  DECORATIVE_ICON_60 = 'DECORATIVE_ICON_60',
  DECORATIVE_ICON_70 = 'DECORATIVE_ICON_70',
  DECORATIVE_SHADE_10 = 'DECORATIVE_SHADE_10',
  DECORATIVE_SHADE_20 = 'DECORATIVE_SHADE_20',
  DECORATIVE_SHADE_30 = 'DECORATIVE_SHADE_30',
  DECORATIVE_SHADE_40 = 'DECORATIVE_SHADE_40',
  DECORATIVE_SHADE_50 = 'DECORATIVE_SHADE_50',
  DECORATIVE_SHADE_60 = 'DECORATIVE_SHADE_60',
  DECORATIVE_SHADE_70 = 'DECORATIVE_SHADE_70',
  DECORATIVE_TINT_10 = 'DECORATIVE_TINT_10',
  DECORATIVE_TINT_20 = 'DECORATIVE_TINT_20',
  DECORATIVE_TINT_30 = 'DECORATIVE_TINT_30',
  DECORATIVE_TINT_40 = 'DECORATIVE_TINT_40',
  DECORATIVE_TINT_50 = 'DECORATIVE_TINT_50',
  DECORATIVE_TINT_60 = 'DECORATIVE_TINT_60',
  DECORATIVE_TINT_70 = 'DECORATIVE_TINT_70',
  TOP_SHOP_ICON_GREEN = 'TOP_SHOP_ICON_GREEN',
  TOP_SHOP_SHADE_GREEN = 'TOP_SHOP_SHADE_GREEN',
  TOP_SHOP_TINT_GREEN = 'TOP_SHOP_TINT_GREEN',
  CORE_SURFACE_DISABLED = 'CORE_SURFACE_DISABLED',
  /**
   * https://www.figma.com/design/mDFMOehyo1z5YWGDxh2lXV/%F0%9F%8C%9E-Faire-Summer-Market-2024
   */
  CORE_SURFACE_PRIMARY_MARKET = 'CORE_SURFACE_PRIMARY_MARKET',
  CORE_BADGE_ICON_MARKET = 'CORE_BADGE_ICON_MARKET',
  CORE_SURFACE_ENABLED = 'CORE_SURFACE_ENABLED',
}
